import useAuth from 'hooks/use-auth'
import { useGremlinPagination } from 'hooks/use-gremlin-query'
import { attacksQueryKeys } from 'queries/attacks/query-keys'
import {
  DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  type PaginatedQueryOptions
} from 'queries/queries-utils'

import type { AttacksActivePagedResponse } from 'types/api/attacks/active/paged'

export function useGetAttacksActiveWithPagination({
  pageSize = DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  ...queryOptions
}: PaginatedQueryOptions<AttacksActivePagedResponse> = {}) {
  const { currentTeamId } = useAuth()

  return useGremlinPagination<AttacksActivePagedResponse>(
    `attacks/active/paged?pageSize=${pageSize}`,
    {},
    {
      ...queryOptions,
      queryKey: attacksQueryKeys.getActivePaged({
        teamId: currentTeamId,
        pageSize
      })
    }
  )
}
